import { put, all, call } from "redux-saga/effects";

import axios from "../../services/axios-service";
import * as actions from "../actions";
import ConsoleLog from "../../hoc/ConsoleLog/ConsoleLog";
import getS3ImageUrl from "../../lib/s3FileHandler";

/**
 * @desc saga for logged-in user profile
 * @version
 * @author Lakshmikanth
 * @return api response
 */
export function* getClientDetailsSaga(action) {
  try {
    if (action.isJobList) {
      const [response, jobTitleResponse] = yield all([
        axios.get("galaxy/user/" + action.clientId),
        axios.get("/galaxy/job?userId=" + action.clientId)
      ]);
      yield all([
        put(actions.setClientDetails(response.data[0])),
        put(actions.setJobList(jobTitleResponse.data))
      ]);

      if (
        response.data[0] &&
        response.data[0].user_image_url !== "" &&
        response.data[0].user_image_url !== null
      ) {
        let payload = {
          userImageUrl: response.data[0].user_image_url,
          loggedInUser: action.loggedInUser
        };
        yield* getUserImageUrlSaga(payload);
      }
    } else {
      const response = yield axios.get("galaxy/user/" + action.clientId);
      yield put(actions.setClientDetails(response.data[0]));
      if (
        response.data[0] &&
        response.data[0].user_image_url !== "" &&
        response.data[0].user_image_url !== null
      ) {
        let payload = {
          userImageUrl: response.data[0].user_image_url,
          loggedInUser: action.loggedInUser
        };
        yield* getUserImageUrlSaga(payload);
      }
    }
  } catch (error) {
    ConsoleLog(error);
  }
}

export function* getUserImageUrlSaga(action) {
  try {
    const response = yield call(
      getS3ImageUrl,
      action.userImageUrl,
      action.loggedInUser
    );
    yield put(actions.updateProfileImage(action.userImageUrl, response));
  } catch (error) {
    ConsoleLog(error);
  }
}

export function* getInterviewListSaga(action) {
  try {
    // const response = yield axios.get("galaxy/interview-scheduler/interview?userId="+ action.recruiterId + "&isCount=1");
    // ConsoleLog("getInterviewListSaga",response);
    // yield put(actions.setInterViewListCount(response.data));
  } catch (error) {
    ConsoleLog(error);
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/clientProfile.js